import type {
  AddFieldPlacementTarget,
  AuthoredEntityOrSingleSchema,
  LoadedAuthoredGeneratedSchema
} from '@cli-types/core-engine/add-field.js'
import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { buildFormPlacementTargets } from './build-form-placement-targets.js'
import { buildSchemaPlacementTargets } from './build-schema-placement-targets.js'

export function buildPlacementTargets(
  loaded: LoadedAuthoredGeneratedSchema
): AddFieldPlacementTarget[] {
  if (loaded.kind === 'form') {
    return buildFormPlacementTargets(loaded.schema as FormSchema)
  }

  return buildSchemaPlacementTargets(loaded.schema as AuthoredEntityOrSingleSchema)
}
